export default __webpack_public_path__ + "static/media/eth-green.b62bc14b.svg";